export const shelfLifeEnums = {
    days: 'Days', 
    weeks: 'Weeks', 
    months: 'Months', 
    years: 'Years'
}

export const paceScaleEnums = {
    per_day: 'Per Day', 
    per_week: 'Per Week', 
    per_month: 'Per Month', 
    per_year: 'Per Year'
}

export const MPBoxType = {
    default: 'default', 
    rule:"rule",
}

export const catRectEnums = {
    default: "default",
    rule: "rule",
    parent: "parent",
}

export const catRuleEnums = {
    other: 'other', 
    cat: 'category',
    subcat: 'sub_category', 
    sup: 'supplier', 
    brand: 'brand'
}

export const simulateSnapshotEnums = {
    normal: 'normal',
    implemented: 'implemented'
}

export const notSimulatedReason = {
    heightIssue: 'heightIssue',
    minQtyIssue: 'minQtyIssue',
    noEnoughSpace: 'noEnoughSpace',
    noTagMatching: 'noTagMatching',
    missingDimensions: 'missing_dimensions',
    none: 'none'
}

// Wire contract for hierarchy-orphaned groups (Planigo-front #12/#15): a
// product whose master data lacks a brand/supplier/subcategory/category
// link is grouped under one of these reserved sentinel ids, which also
// replace the group's name on the wire. Mirrors placeholder-sentinels.ts
// in planigo-simulation-api — do not rename.
export const placeholderGroupSentinels = {
    noBrand: 'no-brand',
    noSupplier: 'no-supplier',
    noSubcategory: 'no-subcategory',
    noCategory: 'no-category',
}

const placeholderGroupLabelKeys = {
    [placeholderGroupSentinels.noBrand]: 'PLACEHOLDER_GROUPS.noBrand',
    [placeholderGroupSentinels.noSupplier]: 'PLACEHOLDER_GROUPS.noSupplier',
    [placeholderGroupSentinels.noSubcategory]: 'PLACEHOLDER_GROUPS.noSubcategory',
    [placeholderGroupSentinels.noCategory]: 'PLACEHOLDER_GROUPS.noCategory',
}

// Display-time mapping for group names: placeholder sentinels become their
// translated label, anything else passes through unchanged. Stored data keeps
// the raw sentinel (it doubles as a dedup/identity key) — only rendering
// should go through this.
export function displayGroupName(value, t) {
    const key = placeholderGroupLabelKeys[value];
    return key ? t(key) : value;
}

export const impleStatus = {
    NONE: "NONE",
    ACTIVE: "ACTIVE",
    CONFIRMED: "CONFIMED"
}
export const SimulationTypesFE={
    IsleAllocation:"ISleAllocation",
    Normal:"Normal",
    AUI:"AUI",
}

export const markSimUpdateTypes = {
    ReApproval: "ReApproval",
    ForceUpdate: "ForceUpdate"
}

export const prodSaleTypes = {
    num: "Fc",
    perc: "Num"
}

export const prodNotificationType = {
    TestPeriodOver: "Test Period is over",
    NewStarIsBorn: "New Star is born",
    InOut: "In & Out",
    FOutOfShelf: "F-Out of shelf", 
    DeadWalker: "Dead Walker" 
}

export const simulationPushMode = {
    custom: "custom",
    branch_selection: "branch_selection",
}